import { defineStore } from "pinia";
import _ from "lodash";

export const useGlobalStore = defineStore("global", {
    state: () => {
        return {
            mobile: false,
            modal: {
                name: null,
                payload: null,
                canClose: true,
            },
        };
    },
    getters: {
        //
    },
    actions: {
        toggleMobile(delta) {
            delta != null
                ? (this.mobile = delta)
                : (this.mobile = !this.mobile);
        },
        setup() {
            //
        },
        //
        openModal(modal) {
            this.modal = {
                name: modal,
                payload: null,
                canClose: true,
            };
            document.body.classList.add("overflow-hidden");
        },
        setModal(modal) {
            this.modal = {
                name: modal[0],
                payload: modal[1],
                canClose: modal[2] ?? true,
            };
            document.body.classList.add("overflow-hidden");
        },
        closeModal() {
            this.modal = {
                name: null,
                payload: null,
                canClose: true,
            };
            document.body.classList.remove("overflow-hidden");
        },
    },
});
